<template>
    <properties-block v-bind="$props" v-on="$listeners">
        <template #layout>
            <b-form-group label-cols="4">
                <template #label>
                    <span v-tr>Column Span|Largeur de la colonne</span>
                    <btn-responsive-prop v-model="block" field="span"/>
                </template>
                <b-select v-model.number="block.mediaProxy.span">
                    <option v-for="n in 10" :key="`columns-${n}`" :value="`${n}`">{{n}} span</option>
                </b-select>
            </b-form-group>
        </template>
    </properties-block>
</template>

<script>
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";

// properties-block-column #hot-reload-debug
export default {
    name: `properties-block-column`,
    components: {PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
